import { TableDefinitionColumn } from './table-definition-column.model';

export class TableSort {
  direction: TableSortDirection;
  column: TableDefinitionColumn;
}

export enum TableSortDirection {
  Ascending = 'asc',
  Descending = 'desc'
}

//A collection of table row elements in a table
export class SelectedRows {
  constructor() {
    this.rows = [];
    this.checkboxEventState = RowCheckedEventState.Unchecked;
  }

  rows: TableRow[];

  //the state of the last touched checkbox (checked or unchecked)
  checkboxEventState: RowCheckedEventState;

  push(id: unknown, index: number) {
    this.rows.push(new TableRow(id, index));
  }
}

//Represents a single row in the table component
export class TableRow {
  constructor(id: unknown, index: number) {
    this.rowId = id;
    this.rowIndex = index;
  }
  //The database Id uniquely defining the row (can also be any unqiue property)
  rowId: unknown;
  //0 based index in the table
  rowIndex: number;
}

//Represents a row in the datatable with a isSelected property
export class SelectableTableRow extends TableRow {
  constructor(id: unknown, index: number) {
    super(id, index);
  }

  isSelected: boolean = false;
  isDeleted: boolean = false;
}

export enum SelectedRowsTableState {
  NonSelected = 1,
  SomeSelected = 2,
  AllSelected = 3
}

export enum RowCheckedEventState {
  Unchecked = 0,
  Checked = 1
}
